<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="回访名称">
          <el-input placeholder="请输入回访名称" v-model="formInline.search">
           
          </el-input>
        </el-form-item>


        <el-form-item label="订单号">
          <el-input style="width: 200px;" placeholder="请输入订单号" v-model="formInline.order">
           
          </el-input>
        </el-form-item>

        <el-form-item label="用户信息">
          <el-input style="width: 200px;" placeholder="请输入手机号/昵称" v-model="formInline.name">
           
          </el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-select size="small" v-model="formInline.status" placeholder="请选择类型">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="回访进行中" :value="0"></el-option>
            <el-option label="回访已完结" :value="1"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>

            <el-button type="primary"  icon="el-icon-search" @click="getData">查询</el-button>
            <el-button  icon="el-icon-search" @click="reast">重置</el-button>
    
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加回访</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="order.order_no" label="订单号"></el-table-column>
            <el-table-column  label="用户">
              <template slot-scope="scope">
                <div v-if=" scope.row.user && scope.row.user.nickName">昵称：{{ scope.row.user.nickName }}</div>
                <div v-if=" scope.row.user && scope.row.user.mobile">手机号：{{ scope.row.user.mobile }}</div>
              </template>

            </el-table-column>
            <el-table-column prop="name" label="回访主题"></el-table-column>
            <el-table-column prop="content" label="回访内容"></el-table-column>
            <el-table-column prop="time" label="回访时间"></el-table-column>
         
            <el-table-column prop="time" label="回访状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0"> 回访进行中</div>
                <div v-if="scope.row.status == 1"> 回访已完结</div>
              </template>
            </el-table-column>

            <el-table-column  label="最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opshopuser &&  scope.row.opshopuser.user_name">{{ scope.row.opshopuser.user_name }}
                <span v-if=" scope.row.opshopuser.real_name">({{ scope.row.opshopuser.real_name }})</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :rvisit_id="rvisit_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import RvisitiApi from '@/api/rvisit.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          order:"",
          status:-1,
          name:""
        },

        open_add:false,
        open_edit:false,
        rvisit_id:""
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      reast(){
        this.formInline = {
          search:"",
          order:"",
          status:-1,
          name:""
        };
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        RvisitiApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      detailClick(row){
        let self = this;
      let params = row.rvisit_id;
      self.$router.push({
        path: '/plus/rvisit/rvisit/part/detail',
        query: {
          rvisit_id: params
        }
      });
      },
      /*编辑活动*/
      editClick(row) {
        this.rvisit_id = row.rvisit_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            RvisitiApi.del(
              {
                rvisit_id: row.rvisit_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/rvisit/rvisit/index.vue